import WorkerDashboardHome from './WorkerDashboardHome';

export default WorkerDashboardHome;
